/**
 * Vite Entry Point
 * Imports all styles and scripts for the frontend
 */

// ============================================
// 1. jQuery MUST be imported first (before all other imports!)
// ============================================
import jQuery from './jquery-global.js';

// ============================================
// 2. Styles (LESS + Vendor CSS)
// ============================================
import '../Less/main.less';

// ============================================
// 3. Libraries (order matters!)
// ============================================
import 'jquery.easing';
import 'jquery-mousewheel';

// Bootstrap 3 individual modules
import 'bootstrap/js/button';
import 'bootstrap/js/carousel';
import 'bootstrap/js/collapse';
import 'bootstrap/js/dropdown';
import 'bootstrap/js/tab';
import 'bootstrap/js/tooltip';
import 'bootstrap/js/transition';

import 'bootstrap-select';
import 'bootstrap-hover-dropdown';
import 'parsleyjs';

import 'owlcarousel/owl-carousel/owl.carousel';
import Cookies from 'js-cookie';
window.Cookies = Cookies;
import 'jquery-match-height';

// Libphonenumber (npm package)
import * as libphonenumber from 'libphonenumber-js';
window.libphonenumber = libphonenumber;

// ============================================
// 4. Custom modules
// ============================================
import './Modules/AjaxRetailers.js';
import './Modules/ButtonManager.js';
import './Modules/FormValidation.js';
import './Modules/GoogleTagManager.js';
import './Modules/EmailValidation.js';
import './Modules/PlaceHolderManager.js';
import './Modules/Products.js';
import './Modules/RegistrationReferrer.js';
import './Modules/UserProfile.js';

// ============================================
// 5. App (initializes everything)
// ============================================
import './app.js';